import { IModalWindow } from '@hooks/useModalWindow';
import { Button, PropTypes } from '@material-ui/core';
import React from 'react';
import { ModalWindow } from './ModalWindow';
import { ModalWindowActions } from './ModalWindowActions';
import { ModalWindowContent } from './ModalWindowContent';
import { ModalWindowTitle } from './ModalWindowTitle';

export type ConfirmModalActionProps = {
    confirmButtonText: string
    confirmButtonColor?: PropTypes.Color
    onConfirm: VoidFunction

    cancelButtonText?: string,
    onCancel?: VoidFunction
}

export type ConfirmModalProps = {
    modal: IModalWindow
    title: string,
    icon?: React.ReactNode,
    content: React.ReactNode,
    disabled: boolean,
    actionProps: ConfirmModalActionProps
}

export function ConfirmModal ({ modal, title, icon, content, disabled, actionProps }: ConfirmModalProps) {
    return (
        <ModalWindow
            disabled={disabled}
            modal={modal}
        >
            <ModalWindowTitle 
                icon={icon}
                title={title}
                hasCloseButton={false}
            />

            <ModalWindowContent>
                {content}
            </ModalWindowContent>

            <ModalWindowActions>
                <Button onClick={actionProps.onCancel !== undefined ? actionProps.onCancel : modal.close}>{actionProps.cancelButtonText !== undefined ? actionProps.cancelButtonText : "Cancelar"}</Button>
                <Button onClick={actionProps.onConfirm} color={actionProps.confirmButtonColor !== undefined ? actionProps.confirmButtonColor : "primary"} variant="contained">{ actionProps.confirmButtonText }</Button>
            </ModalWindowActions>
        </ModalWindow>
    )
}